import { pickWithPriority } from 'Helpers/Affordances';
import PropTypes from 'prop-types';

const SimplePicker = (props) => {
  const {
    resource, relationship: relationshipName, hasRelationship, noRelationship,
  } = props;

  if (!resource) return null;

  const func = pickWithPriority(resource, [
    [relationshipName, hasRelationship],
  ], noRelationship);

  return func({ resource, relationship: resource.relationship(relationshipName) });
};

SimplePicker.defaultProps = {
  noRelationship: () => null,
};

SimplePicker.propType = {
  resource: PropTypes.object.isRequired,
  relationship: PropTypes.string.isRequired,
  hasRelationship: PropTypes.func.isRequired,
  noRelationship: PropTypes.func,
};

export default SimplePicker;
